var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:( _obj = {}, _obj['checkbox'] = true, _obj['checkbox-large'] = _vm.large, _obj )},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }